import React, { useState } from "react";
import { Button, Form, Input, Select, message, Upload } from "antd";
import { PlusOutlined } from "@ant-design/icons";

import WangEditor from "./wangEditor";
import axios from "axios";
import localhost from "../../constants/localhost";

const DraftBox = ({ mode }) => {
  const [content, setContent] = useState("");
  const [form] = Form.useForm();

  const onSave = () => {
    form.validateFields((vals) => {
      const formData = vals;
      axios
        .post(`${localhost}/manage/materialCreation/save`, formData)
        .then((res) => {
          message.success("新增成功");
        })
        .catch((error) => {
          message.error("网络异常，请重试！");
        });
    });
  };

  return (
    <div style={{ height: "100%", overflow: "scroll" }}>
      <h1>素材创作</h1>
      <Form labelCol={{ span: 4 }} wrapperCol={{ span: 20 }} form={form}>
        <Form.Item label="标题" name="title">
          <Input allowClear />
        </Form.Item>
        <Form.Item label="内容场景" name="contentType">
          <Select
            placeholder="请选择内容场景"
            allowClear
            disabled={mode === "detail"}
          >
            <Select.Option value="旅行者分享">旅行者分享</Select.Option>
            <Select.Option value="使用攻略">使用攻略</Select.Option>
            <Select.Option value="活动分享">活动分享</Select.Option>
            <Select.Option value="爱车养车">爱车养车</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="附件" name="file">
          <Upload
            action="/upload.do"
            listType="picture-card"
            disabled={mode === "detail"}
          >
            <button
              style={{
                color: "inherit",
                cursor: "inherit",
                border: 0,
                background: "none",
              }}
              type="button"
            >
              <PlusOutlined />
              <div style={{ marginTop: 8 }}>选择文件</div>
            </button>
          </Upload>
        </Form.Item>
        <Form.Item label="内容" name="content">
          <WangEditor />
        </Form.Item>
      </Form>
      <div style={{ display: "flex", justifyContent: "center", marginTop: 16 }}>
        <Button type="primary" onClick={onSave}>
          保存并新增
        </Button>
      </div>
    </div>
  );
};

export default DraftBox;
